import { Directive, input } from '@angular/core'

import { injectSetPayloadAttributeFn } from 'app/utils/set-payload-attribute.function'
import { explicitEffect } from 'app/utils/signal-utils'

// todo move into reusable type somewhere
interface CmsBlockData {
  __typename: string
  id: string | null // actually never really null
}

@Directive({ selector: '[paiCmsId]', standalone: true })
export class CmsIdDirective {
  readonly item = input.required<CmsBlockData>({ alias: 'paiCmsId' })
  private readonly setPayloadAttributes = injectSetPayloadAttributeFn()

  constructor() {
    explicitEffect(
      this.item,
      ({ id, __typename }: CmsBlockData) => void (id && this.setPayloadAttributes({ id, __typename })),
    )
  }
}
